<template>
    <div>
        <div class="row g-0 mb-2">
            <pc-input
                v-model.trim="email"
                v-bind:label="emailInputLabel"
                v-bind:class="responsiveClasses.editRecipientEmail" />
            <pc-input
                v-model.trim="first"
                v-bind:label="firstNameInputLabel"
                v-bind:class="responsiveClasses.editRecipientFirst" />
            <pc-input
                v-model.trim="last"
                v-bind:label="lastNameInputLabel"
                v-bind:class="responsiveClasses.editRecipientLast" />
        </div>
        <div class="d-flex">
            <div class="d-flex flex-grow-1 justify-content-end">
                <pc-button
                    small
                    v-on:click="onCancel">
                    {{ cancelText }}
                </pc-button>
                <pc-button
                    small
                    primary
                    class="ms-2"
                    v-on:click="onSave">
                    {{ saveText }}
                </pc-button>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/editRecipientContactInfo.i18n";
    import { KEYS as COMMON_KEYS, NAMESPACE as COMMON_NS } from "I18n/common.i18n";
    import { WIDE_BP } from "Projects/SharedCapsules/_sharedCapsuleBase";
    import { getResponsiveClassMap } from "Responsive/manager";

    const responsiveConfig = {
        editRecipientEmail: {
            col: { xs: 12, [WIDE_BP.name]: 6 },
            mb: { xs: 3, [WIDE_BP.name]: 0 }
        },
        editRecipientFirst: {
            col: { xs: 12, [WIDE_BP.name]: 3 },
            mb: { xs: 3, [WIDE_BP.name]: 0 },
            ps: { [WIDE_BP.name]: 2 }
        },
        editRecipientLast: {
            col: { xs: 12, [WIDE_BP.name]: 3 },
            ps: { [WIDE_BP.name]: 2 }
        }
    };

    export default {
        inject: {
            viewport: {
                from: "viewport",
                default: null
            }
        },
        props: {
            initialContactInfo: { type: Object, required: true }
        },
        emits: ["cancel", "update-contact-info"],
        data() {
            return {
                first: this.initialContactInfo.first,
                last: this.initialContactInfo.last,
                email: this.initialContactInfo.email
            };
        },
        computed: {
            responsiveClasses() {
                return getResponsiveClassMap(this.viewport, responsiveConfig);
            },
            updatedContactInfo() {
                return {
                    first: this.first,
                    last: this.last,
                    email: this.email
                };
            },
            ...mapI18n({ ...KEYS }, NAMESPACE),
            ...mapI18n({ ...COMMON_KEYS }, COMMON_NS)
        },
        methods: {
            onCancel() {
                this.$emit("cancel");
            },
            onSave() {
                this.$emit("update-contact-info", this.updatedContactInfo);
            }
        }
    };
</script>
